__turbopack_context__.v({
  "Form": "CampaignFormSection-module-scss-module__x9BQJq__Form",
  "Title": "CampaignFormSection-module-scss-module__x9BQJq__Title",
});
